export default __webpack_public_path__ + "static/media/gwn19.544200b7.webp";